<template>
  <div class="weather-page">
    <template v-if="currentReportType.id == 2">
      <weather-satellite-page></weather-satellite-page>
    </template>
    <template v-if="currentReportType.id == 3">
      <weather-meteorology-page></weather-meteorology-page>
    </template>
    <template v-if="currentReportType.id == 4">
      <weather-maps-page></weather-maps-page>
    </template>
    <template v-if="currentReportType.id == 5">
      <weather-agrometeorology-page></weather-agrometeorology-page>
    </template>
  </div>
</template>

<script>
import WeatherAgrometeorologyPage from "./WeatherAgrometeorologyPage.vue";
import WeatherMapsPage from "./WeatherMapsPage.vue";
import WeatherMeteorologyPage from "./WeatherMeteorologyPage.vue";
import WeatherSatellitePage from "./WeatherSatellitePage.vue";

export default {
  components: {
    WeatherAgrometeorologyPage,
    WeatherMapsPage,
    WeatherMeteorologyPage,
    WeatherSatellitePage,
  },
  data() {
    return {};
  },
  props: {
  },
  computed: {
    currentReportType() {
      return this.$store.state.currentReportType;
    },
  },
  methods: {},
};
</script>

<style>
</style>